export const en = {
    more: 'more'
};
